import React, { useEffect, useRef, useState } from "react"
import AnnouncementMenu from "./AnnouncementMenu"
import { CaretLeft, CaretRight } from "@phosphor-icons/react"

const AnnouncementHeader = () => {
	const [animationKey, setAnimationKey] = useState(0)
	const [announcements, setAnnouncements] = useState([])
	const [currentAnnouncement, setCurrentAnnouncement] = useState(0)
	const [touchActive, setTouchActive] = useState(false)
	let intervalId = useRef(null)

	const globalAnnouncements = [
        /*
        {
			mobile: `<a href='/collections/memorial-day-sale/'>200+ styles now 25% off! 🔥</a>`,
			tablet: `<a href='/collections/memorial-day-sale/'>Over 200 styles at 25% off 🔥</a>`,
			desktop: `<a href='/collections/memorial-day-sale/'>Just in: 200+ summer-ready styles now 25% off sitewide! 🔥</a>`,
		},
        {
			mobile: `<a href='/collections/60-sets/'>Hot sets for $60? Shop now →</a>`,
			tablet: `<a href='/collections/60-sets/'>Shop $60 Sets - our Memorial Day Sale exclusive! →</a>`,
			desktop: `<a href='/collections/60-sets/'>Limited-time hot sets for $60—get your fave before it’s gone 👙 →</a>`,
		},
        
		{
			mobile: `<a href='/memorial-day'>Get EXTRA 10% off the sale! Sign up →</a>`,
			tablet: `<a href='/memorial-day'>Get EXTRA 10% off the sale! Sign up here →</a>`,
			desktop: `<a href='/memorial-day'>Get EXTRA 10% off the Memorial Day Sale! Sign up here →</a>`,
		},
        
        {
			mobile: `<a href='/collections/the-ashley-kelly-edit-island-life/'>🌴 Free Island Life Phone Strap—first 100 only!</a>`,
			tablet: `<a href='/collections/the-ashley-kelly-edit-island-life/'>🌴 Free Island Life Phone Strap—first 100 only!</a>`,
			desktop: `<a href='/collections/the-ashley-kelly-edit-island-life/'>🌴 Free Island Life Phone Strap with any edit purchase – first 100 orders only!</a>`,
		},
        */
		{
			mobile: `<a href='/collections/all/'>FREE SHIPPING on orders over $100!</a>`,
			tablet: `<a href='/collections/all/'>FREE WORLDWIDE SHIPPING on orders over $100! Shop now.</a>`,
			desktop: `<a href='/collections/all/'>FREE WORLDWIDE SHIPPING on orders over $100! Shop now.</a>`,
		},
        /*
		{
			mobile: `<a href='/collections/all/'>Get a free sarong—spend $150!</a>`,
			tablet: `<a href='/collections/all/'>Orders $150+ come with a free sarong 💕 →</a>`,
			desktop: `<a href='/collections/all/'>Spend $150 and get a free sarong—limited time only! →</a>`,
		},
        */
	]

	const phAnnouncements = [
        /*
        {
			mobile: `<a href='/collections/the-ashley-kelly-edit-island-life/'>First 100 any edit purchase Free Island Life Phone Strap!</a>`,
			tablet: `<a href='/collections/the-ashley-kelly-edit-island-life/'>First 100 any edit purchase Free Island Life Phone Strap!</a>`,
			desktop: `<a href='/collections/the-ashley-kelly-edit-island-life/'>🌴 Free Island Life Phone Strap with any edit purchase – first 100 orders only!</a>`,
		},
        */
		{
			mobile: `<a href='/collections/3500-sets'>The hottest swim sets at ₱3500 →</a>`,
			tablet: `<a href='/collections/3500-sets'>The hottest swim sets for the season — now at P3500! &#128089;</a>`,
			desktop: `<a href='/collections/3500-sets'>The hottest swim sets for the season — now at P3500! &#128089;</a>`,
		},
		
		{
			mobile: `<a href='/collections/all/'>FREE SHIPPING NATIONWIDE. Shop now!</a>`,
			tablet: `<a href='/collections/all/'>FREE SHIPPING NATIONWIDE. Shop now!</a>`,
			desktop: `<a href='/collections/all/'>FREE SHIPPING NATIONWIDE. Shop now!</a>`,
		},
	]

	useEffect(() => {
		//mock api call
		setAnnouncements(
			process.env.GATSBY_STORE !== "PH" ? globalAnnouncements : phAnnouncements
		)
	}, [])

	useEffect(() => {
		if (announcements.length > 0) startInterval()

		return () => {
			stopInterval() // Cleanup on unmount
		}
	}, [announcements.length])

	useEffect(() => {
		if (touchActive) stopInterval()
		else startInterval()
	}, [touchActive])

	const startInterval = () => {
		if (intervalId.current) clearInterval(intervalId.current)

		intervalId.current = setInterval(() => {
			setCurrentAnnouncement((prev) => (prev + 1) % announcements.length)
		}, 11000)
	}

	const stopInterval = () => {
		if (intervalId.current) clearInterval(intervalId.current)
	}

	const handleNextAnnouncement = (val) => {
		const announcementIndex =
			currentAnnouncement === 0 && val === -1
				? announcements.length - 1
				: currentAnnouncement === announcements.length - 1 && val === 1
				? 0
				: currentAnnouncement + val

		clearInterval(intervalId)
		setAnimationKey((prev) => prev + 1)
		setCurrentAnnouncement(announcementIndex)
		startInterval()
	}

	return (
		<React.Fragment>
			<div className="relative flex gap-x-6 bg-black px-6 py-2.5 sm:px-3.5 h-10 text-white text-sm z-[51]">
				<div
					className={`relative flex justify-between items-center max-w-[1440px] mx-auto flex-1 md:gap-x-4`}
				>
					{announcements.length > 0 && (
						<>
							{/* <div
                className={`block lg:hidden before:content-[''] before:absolute before:inset-0 before:bg-marquee-gradient overflow-hidden w-[92vw] md:w-[460px] lg:w-[570px] xl:w-[920px] absolute h-full z-10 pointer-events-none -ml-1 md:ml-6`}
              /> */}
							{/* <div className="absolute flex flex-nowrap justify-between w-[90vw] md:w-[456px] lg:w-[600px] xl:w-[850px] -ml-1 md:ml-3 z-20 pointer-events-none"> */}
							<div className="absolute left-0 flex flex-nowrap justify-between w-full md:w-[482px] lg:w-[600px] xl:w-[850px] px-4 md:px-0 md:ml-3 z-20 pointer-events-none">
								<CaretLeft
									className={`cursor-pointer self-start pointer-events-auto`}
									size={16}
									onClick={() => handleNextAnnouncement(-1)}
								/>
								<CaretRight
									className={`cursor-pointer self-end pointer-events-auto`}
									size={16}
									onClick={() => handleNextAnnouncement(1)}
								/>
							</div>
							{/* <div className={`relative flex overflow-hidden w-full md:w-[420px] lg:w-[550px] xl:w-[800px] h-full ml-0 md:ml-8 z-0`}> */}
							<div
								className={`relative flex overflow-hidden w-full md:w-[482px] lg:w-[550px] xl:w-[800px] h-full z-0`}
							>
								<div
									key={animationKey}
									className="absolute lg:px-4 left-0 w-full flex items-center cursor-pointer"
									// onTouchStart={setTouchActive(!touchActive)}
								>
									<div
										className={`inline-block text-center whitespace-nowrap animate-fade-in-out animate w-full ${
											touchActive ? "animation-paused" : "animation-running"
										} announcement-container`}
										onMouseEnter={() => setTouchActive(true)}
										onMouseLeave={() => setTouchActive(false)}
									>
										<div
											className="block md:hidden"
											dangerouslySetInnerHTML={{
												__html: announcements[currentAnnouncement]?.mobile,
											}}
										/>
										<div
											className="hidden md:block lg:hidden"
											dangerouslySetInnerHTML={{
												__html: announcements[currentAnnouncement]?.tablet,
											}}
										/>
										<div
											className="hidden lg:block"
											dangerouslySetInnerHTML={{
												__html: announcements[currentAnnouncement]?.desktop,
											}}
										/>
									</div>
								</div>
							</div>
						</>
					)}
					<AnnouncementMenu />
				</div>
			</div>
		</React.Fragment>
	)
}

export default AnnouncementHeader
